export default __webpack_public_path__ + "static/media/landing_intro.912958db.mp4";